<template>
  <!-- 用户管理-用户交易链接封禁 -->
  <div class="user_transaction_link-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input
            clearable
            v-model.trim="query.transaction_url"
            placeholder="请输入交易链接"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            style="width: 150px"
            clearable
            v-model.trim="query.user_id"
            placeholder="请输入用户ID"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <div v-loading="loading">
        <div v-if="activeTable === 'id'">
          <el-table :data="dataList">
            <el-table-column
              prop="before_url"
              label="变更前URL"
            ></el-table-column>
            <el-table-column
              prop="after_url"
              label="变更后URL"
            ></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column
              prop="updated_at"
              label="变更时间"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="activeTable === 'url'">
          <el-table v-loading="loading" :data="dataList">
            <el-table-column prop="user_id" label="用户id"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column
              prop="created_at"
              label="变更时间"
            ></el-table-column>
          </el-table>
        </div>

        <!-- 底部分页条 -->
        <el-pagination
          background
          :page-size="dataMeta.per_page || 15"
          :total="dataMeta.total || 0"
          :current-page="dataMeta.current_page"
          @current-change="handlePageChange"
          v-if="dataMeta && dataMeta.total > dataMeta.per_page"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { patchData, postData, getData, getApiData, patchApiData, postApiData, delApiData } from '@/http'
import AddBanLinkDialog from '@/components/user/user_transaction_link/AddBanLinkDialog.vue'

export default {
  name: 'user_transaction_link',
  components: {
    AddBanLinkDialog
  },
  data() {
    return {
      addViaible: false,//添加封禁链接
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      activeTable: 'url',//url是查交易链接 id是查用户id
      query: {//查询条件
        page: 1,
        transaction_url: undefined,//交易链接
        user_id: undefined,//用户id
      },
      dataList: undefined,//数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  watch: {
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      //获取列表数据
      if (this.query.transaction_url) {
        this.activeTable = 'url'
      } else if (this.query.user_id) {
        this.activeTable = 'id'
      }


      let params = this.query
      if (this.query.transaction_url) {
        this.loading = true
        getApiData('transaction_url_record', params).then(res => {
          if (res) {
            this.dataList = res
            //设置底部导航条数据
            // this.dataMeta = res.meta
          }
        }).finally(() => {
          this.loading = false
        })
      } else if (this.query.user_id) {
        this.loading = true
        getData(`url_record/${this.query.user_id}`, params)
          .then(res => {
            this.dataList = res.data
            this.dataMeta = res.meta
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.user_transaction_link-box {
  header {
  }

  .body-box {
  }
}
</style>